import { Component } from '@angular/core';
import { Session } from "../../services/Session";
import { Locations } from "../../services/Locations";
import { ILocation } from "../../interfaces/ILocation";
import { Distributors } from "../../services/Distributors";
import { Specialties } from "../../services/Specialties";
import { Cots } from "../../services/Cots";
import { TaxStatuses } from "../../services/TaxStatuses";
import { Themes } from "../../services/Themes";
import { IDistributor } from "../../interfaces/IDistributor";
import { ICot } from "../../interfaces/ICot";
import { ICotInternal } from "../../interfaces/ICotInternal";
import { ITheme } from "../../interfaces/ITheme";
import { ISubTheme } from "../../interfaces/ISubTheme";
import { ISpecialty } from "../../interfaces/ISpecialty";
import { ITaxStatus } from "../../interfaces/ITaxStatus";
import { Helpers } from "../../services/Helpers";
import { Notify } from "../../services/Notify";
import { User } from '../../services/User';
import { IRep } from '../../interfaces/IRep';
import { IUser } from '../../interfaces/IUser';

@Component({
  templateUrl: 'bulk_upload.html',
  selector: 'bulk-upload'
})
export class BulkUploadCmp {
  public newFileData: File;
  public newFileName: string;
  public uploadingFile: boolean = false;
  public parsingHeaders: boolean = false;
  public afterParsingHeaders: boolean = false;
  public afterParsingFile: boolean = false;
  public fileHeadersList: { index: number, columns_str: string }[];
  public headersIndex: number = 0;
  public parsing = false;
  public columnsList;
  public columnsMap;
  public parentLoc: ILocation;
  public req = this.getEmptyReq();
  public info = { lines_inserted: 0, errors: 0, status: '' };
  public distributorsList: IDistributor[] = [];
  public specialtiesMap = {};
  public specialtiesList: ISpecialty[] = [];
  public cotsList: ICot[] = [];
  public cotsInternalList: ICotInternal[] = [];
  public taxStatusesList: ITaxStatus[] = [];
  public themes: Array<ITheme> = [];
  public subThemes: Array<ISubTheme> = [];
  private fileHeaders: { [row: number]: { [column: number]: string } };
  private n = new Notify();
  private reps: IRep[] = [];
  private emailToUserIdMap: { [email: string]: number } = {};

  constructor(private session: Session, private locations: Locations, public distributors: Distributors, public specialties: Specialties,
    public cots: Cots, public taxStatus: TaxStatuses, public themesSrv: Themes, private h: Helpers, public user: User) {
    this.session.redirectIfNotAuth();
    this.distributors.loadToList(this.distributorsList);
    this.specialties.loadToList(this.specialtiesList);
    this.cots.loadToList(this.cotsList);
    this.cots.loadInternalToList(this.cotsInternalList);
    this.taxStatus.loadToList(this.taxStatusesList);
    this.themesSrv.getThemes().subscribe((t) => { this.themes = t; }, () => { });
    this.themesSrv.getSubThemes().subscribe((t) => { this.subThemes = t; }, () => { });
    this.user.getReps().subscribe((reps) => {
      this.reps = reps;
    });
  }

  getEmptyReq() {
    return {
      membership_comments: 0,
      zimmer_co_id: 1,
      facility_name: 2,
      dba: 3,
      address: 4,
      address2: 5,
      city: 6,
      state: 7,
      zip: 8,
      phone: 9,
      relationship_to_parent: 10,
      class_of_trade: 11,
      class_of_trade_internal_primary: 12,
      class_of_trade_internal_sub: 13,
      tax_status: 14,
      company_name: 15,
      group_name: 16,
      division_name: 17,
      market_name: 18,
      gln: 19,
      purchasing_contact_fname: 20,
      purchasing_contact_lname: 21,
      purchasing_contact_phone: 22,
      purchasing_contact_email: 23,
      hin: 24,
      dea: 25,
      dea_name: 26,
      specialty: 27,
      ms_date: 28,
      pharma_eff_date: 29,
      distributor: 30,
      ship_to_primary: 31,
      rep_primary: 32,
      distributor_secondary: 33,
      ship_to_secondary: 34,
      rep_secondary: 35,
      website: 36,
      theme: 37,
      sub_theme: 38,
      authority_to_sign: 39,
      is_roster_checked: 40,
      rebate_location_recipient: 41
    };
  }

  addFile(files) {
    if (!files || !files[0]) {
      return;
    }
    this.newFileName = files[0].name;
    this.newFileData = files[0];
    this.afterParsingHeaders = false;
    this.req = this.getEmptyReq();
    this.parseFile();
  }

  parseFile() {
    if (!this.newFileData) {
      return false;
    }
    this.parsingHeaders = true;
    this.afterParsingHeaders = false;
    this.columnsList = null;
    this.columnsMap = null;
    this.locations.parseFileXLS(this.newFileData, 1000, []).subscribe((resp: any) => {
      this.parsingHeaders = false;
      this.afterParsingHeaders = true;
      if (resp && resp.lines) {
        this.fileHeaders = resp.lines;
        this.fileHeadersList = [];
        for (let hi in this.fileHeaders) {
          this.fileHeadersList.push({ index: parseInt(hi), columns_str: Object.values(this.fileHeaders[hi]).join("; ") });
        }
        this.selectHeadersIndex(resp.headers_index);
        this.loadUserEmailsFromFile().then(() => {
          this.checkTextToIDConversions();
        });
      }
    }, (err) => {
      this.parsingHeaders = false;
      console.error(err);
    });
  }

  selectHeadersIndex(i) {
    this.headersIndex = i;
    this.columnsMap = this.fileHeaders[this.headersIndex];
    this.columnsList = Object.values(this.fileHeaders[this.headersIndex]);
  }

  setParentLocation(loc: ILocation) {
    if (!loc || !loc.id) {
      return;
    }
    this.parentLoc = loc;
  }

  resetFileUpload() {
    this.info = { lines_inserted: 0, errors: 0, status: '' };
    this.newFileData = null;
    this.newFileName = null;
    this.columnsList = null;
    this.columnsMap = null;
    this.headersIndex = null;
    this.fileHeaders = null;
    this.fileHeadersList = null;
    this.afterParsingHeaders = false;
    this.afterParsingFile = false;
  }

  getRepIdByName(name: string): number {
    if (!name || name.length < 3 || !this.reps || !this.reps.length) {
      return null;
    }
    name = name.toLowerCase().trim();
    for (let r of this.reps) {
      let fullName = (r.fname + ' ' + r.lname).toLowerCase().trim();
      if (fullName === name) {
        return r.id;
      }
    }
    return null;
  }

  getUserIdByEmail(email: string): number {
    if (!email) {
      return null;
    }
    email = email.toLowerCase().trim();
    return this.emailToUserIdMap[email] || null;
  }

  loadUserEmailsFromFile(): Promise<void> {
    return new Promise((resolve) => {
      if (!this.fileHeaders) {
        resolve();
        return;
      }

      let uniqueEmails = new Set<string>();
      Object.entries(this.fileHeaders).forEach(([i, line]) => {
        if (parseInt(i) <= this.headersIndex) {
          return;
        }
        let email = line[this.req.purchasing_contact_email];
        if (email && email.trim().length > 0) {
          uniqueEmails.add(email.toLowerCase().trim());
        }
      });

      if (uniqueEmails.size === 0) {
        resolve();
        return;
      }

      this.emailToUserIdMap = {};
      let emailSearchPromises = Array.from(uniqueEmails).map(email => {
        return new Promise<void>((emailResolve) => {
          this.user.getUsersList(email, 0, 100).subscribe((users) => {
            if (users && users.length > 0) {
              for (let user of users) {
                if (user.email && user.email.toLowerCase().trim() === email) {
                  this.emailToUserIdMap[email] = user.id;
                  break;
                }
              }
            }
            emailResolve();
          }, () => {
            emailResolve();
          });
        });
      });

      Promise.all(emailSearchPromises).then(() => {
        resolve();
      });
    });
  }

  addFileContent() {
    if (!this.newFileData || !this.parentLoc) {
      return;
    }
    this.parsing = true;
    this.afterParsingFile = false;
    this.info = { lines_inserted: 0, errors: 0, status: '' };
    let inserted = 0;
    let queries = 0;
    let errors = 0;
    let c = () => {
      if (queries <= 0) {
        this.info = { lines_inserted: inserted, errors: errors, status: 'Completed' };
        this.parsing = false;
        this.afterParsingFile = true;
      } else {
        this.info = { lines_inserted: inserted, errors: errors, status: 'In progress' };
      }
    };

    this.locations.parseFileXLS(this.newFileData, 1000, [this.req.ms_date, this.req.pharma_eff_date]).subscribe((resp: any) => {
      if (resp && resp.lines) {
        this.fileHeaders = resp.lines;
        this.fileHeadersList = [];
        for (let hi in this.fileHeaders) {
          this.fileHeadersList.push({ index: parseInt(hi), columns_str: Object.values(this.fileHeaders[hi]).join("; ") });
        }
      } else {
        c();
        this.n.error('No records parsed');
        return;
      }

      this.loadUserEmailsFromFile().then(() => {
        this.processFileRows(); // now uses class helper methods
      });
    }, (err) => {
      this.parsing = false;
      this.afterParsingFile = true;
      c();
      this.n.error('File can\'t be parsed');
    });
  }

  // processFileRows now uses class-level helper methods
  processFileRows() {
    let inserted = 0;
    let queries = 0;
    let errors = 0;
    const c = () => {
      if (queries <= 0) {
        this.info = { lines_inserted: inserted, errors: errors, status: 'Completed' };
        this.parsing = false;
        this.afterParsingFile = true;
        if (errors > 0) {
          this.n.warning('Upload completed', inserted + ' inserted, ' + errors + ' errors');
        } else {
          this.n.success('Upload completed', inserted + ' inserted');
        }
      } else {
        this.info = { lines_inserted: inserted, errors: errors, status: 'In progress' };
      }
    };

    Object.entries(this.fileHeaders).forEach(([i, line]) => {
      if (parseInt(i) <= this.headersIndex) {
        return;
      }
      let loc_name = line[this.req.facility_name];
      if (!loc_name || loc_name.length < 2) {
        return;
      }
      let loc: any = {
        location_group_id: this.parentLoc.location_group_id,
        primary_contact_user_id: this.getUserIdByEmail(line[this.req.purchasing_contact_email]) || this.parentLoc.primary_contact_user_id,
        __rep_user_id: this.getRepIdByName(line[this.req.rep_primary]) || this.parentLoc.__rep_user_id,
        __rep_secondary_id: this.getRepIdByName(line[this.req.rep_secondary]) || this.parentLoc.__rep_secondary_id,
        hin: line[this.req.hin],
        medsurg_eff_date: line[this.req.ms_date] || this.parentLoc.medsurg_eff_date,
        pharma_eff_date: line[this.req.pharma_eff_date] || null,
        facility_name: line[this.req.facility_name],
        dba: line[this.req.dba],
        address: line[this.req.address],
        address2: line[this.req.address2],
        city: line[this.req.city],
        state: line[this.req.state],
        zip: this.normalizeZipCode(line[this.req.zip]),
        phone: line[this.req.phone],
        relationship_to_parent: line[this.req.relationship_to_parent],
        class_of_trade_id: this.h.findObjIdByField(this.cotsList, 'name', line[this.req.class_of_trade]) || this.parentLoc.class_of_trade_id,
        class_of_trade_internal_primary_id: this.h.findObjIdByField(this.cotsInternalList, 'label', line[this.req.class_of_trade_internal_primary]) || this.parentLoc.class_of_trade_internal_primary_id,
        class_of_trade_internal_sub_id: this.h.findObjIdByField(this.cotsInternalList, 'label', line[this.req.class_of_trade_internal_sub]) || this.parentLoc.class_of_trade_internal_sub_id,
        tax_status_id: this.h.findObjIdByField(this.taxStatusesList, 'name', line[this.req.tax_status]) || this.parentLoc.tax_status_id,
        company_name: line[this.req.company_name] || this.parentLoc.company_name,
        group_name: line[this.req.group_name] || this.parentLoc.group_name,
        division_name: line[this.req.division_name] || this.parentLoc.division_name,
        market_name: line[this.req.market_name] || this.parentLoc.market_name,
        gln: this.normalizeGln(line[this.req.gln]),
        dea: line[this.req.dea],
        dea_name: line[this.req.dea_name],
        specialty_id: this.h.findObjIdByField(this.specialtiesList, 'name', line[this.req.specialty]) || this.parentLoc.specialty_id,
        membership_comments: line[this.req.membership_comments],
        zimmer_co_id: this.normalizeNumberString(line[this.req.zimmer_co_id]),
        __distributor_id: this.h.findObjIdByField(this.distributorsList, 'name', line[this.req.distributor]) || this.parentLoc.__distributor_id,
        __distributor_ship_to: line[this.req.ship_to_primary] || this.parentLoc.__distributor_ship_to,
        __distributor_secondary_id: this.h.findObjIdByField(this.distributorsList, 'name', line[this.req.distributor_secondary]) || this.parentLoc.__distributor_secondary_id,
        __secondary_distributor_ship_to: line[this.req.ship_to_secondary] || this.parentLoc.__secondary_distributor_ship_to,
        website: line[this.req.website],
        theme_id: this.h.findObjIdByField(this.themes, 'name', line[this.req.theme]) || this.parentLoc.theme_id,
        sub_theme_id: this.h.findObjIdByField(this.subThemes, 'name', line[this.req.sub_theme]) || this.parentLoc.sub_theme_id,
        __group_authority_to_sign: line[this.req.authority_to_sign] === "Yes" ? true : false,
        is_roster_checked: line[this.req.is_roster_checked] === "Yes" ? 1 : 0,
        rebate_location_recipient: line[this.req.rebate_location_recipient] === "Yes",
        pa_date: this.parentLoc.pa_date,
      };
      queries++;
      this.locations.updateLocation(<any>loc).then(() => {
        inserted++;
        queries--;
        c();
      }, () => {
        errors++;
        queries--;
        c();
      });
    });
  }

  checkTextToIDConversions(calledExplicitly?) {
    let cot = 0;
    let cotInt = 0;
    let cotIntSub = 0;
    let taxStatus = 0;
    let specialty = 0;
    let distr = 0;
    let distrSec = 0;
    let theme = 0;
    let subTheme = 0;
    let repPrimary = 0;
    let repSecondary = 0;
    let purchasingContact = 0;
    let total = 0;

    Object.entries(this.fileHeaders).forEach(([i, line]) => {
      if (parseInt(i) <= this.headersIndex) return;
      total++;

      if (line[this.req.class_of_trade] && !this.h.findObjByField(this.cotsList, 'name', line[this.req.class_of_trade])) {
        cot++;
      }
      if (line[this.req.class_of_trade_internal_primary] && !this.h.findObjByField(this.cotsInternalList, 'label', line[this.req.class_of_trade_internal_primary])) {
        cotInt++;
      }
      if (line[this.req.class_of_trade_internal_sub] && !this.h.findObjByField(this.cotsInternalList, 'label', line[this.req.class_of_trade_internal_sub])) {
        cotIntSub++;
      }
      if (line[this.req.tax_status] && !this.h.findObjByField(this.taxStatusesList, 'name', line[this.req.tax_status])) {
        taxStatus++;
      }
      if (line[this.req.specialty] && !this.h.findObjByField(this.specialtiesList, 'name', line[this.req.specialty])) {
        specialty++;
      }
      if (line[this.req.distributor] && !this.h.findObjByField(this.distributorsList, 'name', line[this.req.distributor])) {
        distr++;
      }
      if (line[this.req.distributor_secondary] && !this.h.findObjByField(this.distributorsList, 'name', line[this.req.distributor_secondary])) {
        distrSec++;
      }
      if (line[this.req.theme] && !this.h.findObjByField(this.themes, 'name', line[this.req.theme])) {
        theme++;
      }
      if (line[this.req.sub_theme] && !this.h.findObjByField(this.subThemes, 'name', line[this.req.sub_theme])) {
        subTheme++;
      }
      if (line[this.req.rep_primary] && !this.getRepIdByName(line[this.req.rep_primary])) {
        repPrimary++;
      }
      if (line[this.req.rep_secondary] && !this.getRepIdByName(line[this.req.rep_secondary])) {
        repSecondary++;
      }
      if (line[this.req.purchasing_contact_email] && !this.getUserIdByEmail(line[this.req.purchasing_contact_email])) {
        purchasingContact++;
      }
    });

    if (total > 0) {
      let failedColumns = [];
      const threshold = 0.25;

      const check = (count, label) => {
        if (count / total > threshold) {
          failedColumns.push(`${label} (${Math.round((count / total) * 100)}%)`);
        }
      };

      check(cot, 'Class of Trade');
      check(cotInt, 'Class of Trade Int. Primary');
      check(cotIntSub, 'Facility Type');
      check(taxStatus, 'Tax Status');
      check(specialty, 'Specialty');
      check(distr, 'Primary Distributor');
      check(distrSec, 'Secondary Distributor');
      check(theme, 'Theme');
      check(subTheme, 'Sub Theme');
      check(repPrimary, 'Primary Rep Name');
      check(repSecondary, 'Secondary Rep Name');
      check(purchasingContact, 'Purchasing Contact Email');

      if (failedColumns.length > 0) {
        this.n.warning(`Values can't be found for ${failedColumns.length} columns`, failedColumns.join(', '));
      } else if (calledExplicitly) {
        this.n.success('Checked successfully!');
      }
    } else {
      if (calledExplicitly) {
        this.n.warning('No records parsed');
      }
    }
  }

  // Helper moved to class scope and typed
  private normalizeNumberString(value: string | number | null | undefined): string | number | null | undefined {
    if (value == null) return value;
    const num = Number(value);
    if (Number.isNaN(num)) return value;
    return Number.isInteger(num) ? num.toString() : value;
  }

  private normalizeZipCode(value: string | number | null | undefined): string | null | undefined {
    if (value == null) return value.toString();
    const str = String(value).trim();
    if (/^\d+$/.test(str) && str.length < 5) {
      return str.padStart(5, '0');
    }
    return str;
  }

  private normalizeGln(value: unknown): string | unknown {
    if (value == null) return value;

    const str = String(value).trim();
    if (!/^[\d.eE+-]+$/.test(str)) return str;

    // If not scientific notation, just return as-is
    if (!/e/i.test(str)) return str;

    // Handle scientific notation safely
    const num = Number(str);
    if (Number.isNaN(num)) return str;

    // Convert to full string form without grouping
    const plain = num.toLocaleString("fullwide", { useGrouping: false });

    // Remove any trailing ".0"
    return plain.endsWith(".0") ? plain.slice(0, -2) : plain;
  }
}
